export default {
  title: 'De import is bezig... 🙂',
  description: 'Slack-meldingen worden verstuurd wanneer de import is voltooid.',
  buttons: {
    open_followers_list: 'Volgerslijst openen',
  },
};
